import { george, i18n, inject, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { NativeRaisedButton } from "components/common/NativeRaisedButton";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { JuniorRoutes } from "./JuniorRoutes";
import { JuniorStore } from "./JuniorStore";

type StatusVariant = "activateSuccess" | "activateError" | "activationSuccess" | "activationError";

const STATUS_CONFIG: Record<
    StatusVariant,
    { image: string; headlineKey: string; descriptionKey: string; buttonKey: string; altKey: string }
> = {
    activateSuccess: {
        image: require("../../assets/gJunior/checkmark_circle.svg"),
        headlineKey: "gJunior.activate.success.headline",
        descriptionKey: "gJunior.activate.success.description",
        buttonKey: "gJunior.activate.success.button",
        altKey: "George Junior Activate Success",
    },
    activateError: {
        image: require("../../assets/gJunior/error_circle.svg"),
        headlineKey: "gJunior.activate.error.headline",
        descriptionKey: "gJunior.activate.error.description",
        buttonKey: "gJunior.activate.error.button",
        altKey: "George Junior Activate Error",
    },
    activationSuccess: {
        image: require("../../assets/gJunior/checkmark_circle.svg"),
        headlineKey: "gJunior.activation.success.headline",
        descriptionKey: "gJunior.activation.success.description",
        buttonKey: "gJunior.activation.success.button",
        altKey: "George Junior Activation Success",
    },
    activationError: {
        image: require("../../assets/gJunior/error_circle.svg"),
        headlineKey: "gJunior.activation.error.headline",
        descriptionKey: "gJunior.activation.error.description",
        buttonKey: "gJunior.activation.error.button",
        altKey: "George Junior Activation Error",
    },
};

function getStatusVariant(pathname: string): StatusVariant {
    switch (pathname) {
        case JuniorRoutes.ACTIVATE_SUCCESS: return "activateSuccess";
        case JuniorRoutes.ACTIVATE_ERROR: return "activateError";
        case JuniorRoutes.ACTIVATION_SUCCESS: return "activationSuccess";
        case JuniorRoutes.ACTIVATION_ERROR: return "activationError";
        default: return "activateError";
    }
}

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: JuniorStore;
}

@inject("externalInterfaceStore")
export class StatusPage extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        const { store } = this.props;
        const isMobile = this.props.externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;
        const statusVariant = getStatusVariant(this.props.location.pathname);
        const config = STATUS_CONFIG[statusVariant];

        if (store.isLoading) {
            return (
                <george.Background>
                    <george.LoadingIndicator isLoading={store.isLoading} height={ui.windowHeight} />
                </george.Background>
            );
        }

        type TranslationKey = Parameters<typeof ui.__>[0];
        const childName = store.selectedChild?.name ?? "";
        const headline = statusVariant === "activateSuccess"
            ? childName
                ? ui.__(config.headlineKey as TranslationKey, { childName })
                : ui.__("gJunior.activate.success.headline.default")
            : ui.__(config.headlineKey as TranslationKey);
        const description = ui.__(config.descriptionKey as TranslationKey);
        const buttonLabel = ui.__(config.buttonKey as TranslationKey);
        const handleClick = () => {
            if (statusVariant === "activateSuccess") {
                pushRoute(JuniorRoutes.ACTIVATION_DOWNLOAD_APP);
            } else {
                pushRoute(JuniorRoutes.OVERVIEW);
            }
        };

        return (
            <george.Background style={{ display: "flex", flexDirection: "column" }}>
                <div style={{
                    backgroundColor: theme.themeColors.georgeBlue_surface,
                    padding: theme.MARGIN,
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                }}>
                    <div style={{
                        textAlign: "center",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                    }}>
                        <img
                            src={config.image}
                            alt={config.altKey}
                            style={{
                                height: "auto",
                                maxWidth: 220,
                                maxHeight: 220,
                                borderRadius: 8,
                                marginBottom: theme.MARGIN_LARGE,
                                alignSelf: "center",
                            }}
                        />
                        <pr.LandingPageTitle style={{
                            color: "white",
                            margin: `${theme.MARGIN} 0`,
                            fontSize: 24,
                            lineHeight: "32px",
                            fontWeight: 700
                        }}>
                            {headline}
                        </pr.LandingPageTitle>

                        <pr.P_16_CONTENT dangerouslySetInnerHTML={{ __html: description }}
                            style={{
                                color: "white",
                                marginBottom: theme.MARGIN,
                                opacity: 0.9,
                                whiteSpace: "pre-line",
                                fontWeight: 400
                            }} />
                    </div>
                    <div style={{
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        gap: theme.MARGIN,
                    }}>
                        <NativeRaisedButton
                            className="theme-action-button-background-color"
                            style={{
                                height: 56,
                                boxShadow: "none",
                                borderRadius: theme.BORDER_RADIUS_FULL,
                                backgroundColor: "white",
                                marginBottom: theme.MARGIN,
                            }}
                            fullWidth={isMobile}
                            primary
                            labelStyle={{ color: theme.themeColors.georgeBlue_surface, fontSize: 18, fontWeight: 600 }}
                            label={buttonLabel}
                            onClick={handleClick}
                        />
                    </div>
                </div>
            </george.Background>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gJunior/StatusPage.tsx